import { render, staticRenderFns } from "./FormModal.vue?vue&type=template&id=48def3b6&scoped=true"
import script from "./FormModal.vue?vue&type=script&lang=js"
export * from "./FormModal.vue?vue&type=script&lang=js"
import style0 from "./FormModal.vue?vue&type=style&index=0&id=48def3b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48def3b6",
  null
  
)

export default component.exports